// src/components/RegisterForm.js
import React, { useState } from 'react';
import { auth, db } from '../firebase';
import {
  createUserWithEmailAndPassword,
  updateProfile
} from 'firebase/auth';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  serverTimestamp
} from 'firebase/firestore';
import './AuthForm.styles.scss';

export default function RegisterForm() {
  const [username, setUsername]   = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName]   = useState('');
  const [email, setEmail]         = useState('');
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [error, setError]         = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    // basic validation
    if (!username.trim())           return setError('Choose a username');
    if (!firstName.trim()||!lastName.trim())
      return setError('Enter both first and last name');
    if (password !== confirm)       return setError("Passwords don't match");

    try {
      // 1) Check username uniqueness
      const usersRef = collection(db, 'users');
      const q        = query(usersRef, where('username', '==', username.trim()));
      const snap     = await getDocs(q);
      if (!snap.empty) {
        return setError('Username already taken');
      }

      // 2) Create user in Auth
      const cred = await createUserWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );
      const user = cred.user;

      // 3) Set their displayName to the username
      await updateProfile(user, { displayName: username.trim() });

      // 4) Persist full profile in Firestore
      await setDoc(doc(db, 'users', user.uid), {
        uid:       user.uid,
        email:     user.email,
        username:  username.trim(),
        firstName: firstName.trim(),
        lastName:  lastName.trim(),
        createdAt: serverTimestamp()
      });

    } catch (err) {
      setError('Failed to register: ' + err.message);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Create an Account</h2>
      {error && <p className="error">{error}</p>}

      <label>
        Username
        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
        />
      </label>

      <label>
        First Name
        <input
          type="text"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
          required
        />
      </label>

      <label>
        Last Name
        <input
          type="text"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
          required
        />
      </label>

      <label>
        Email
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
      </label>

      <label>
        Password
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
      </label>

      <label>
        Confirm Password
        <input
          type="password"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          required
        />
      </label>

      <button type="submit">Sign Up</button>
    </form>
  );
}
